// This file includes polyfills needed by Angular 2 and is loaded before
// the app. You can add your own extra polyfills to this file.

import 'zone.js';  // Included with Angular CLI.
(window as any).global = window;
